<script>
import Layout from "../../layouts/main";
import Banner from "@/components/banner.vue"
import FaqS from "@/components/faqComponent.vue"


export default ({
  name: "History",

  components: {
    Layout, Banner ,FaqS
  },

  props: {
   
    },

    data() {
        return{
            isCollapsed: []  ,

            open: false
        }
    },
   

  mounted() {

  },

  
  methods: {

    toggleCollapse(index) {

      this.$set(this.isCollapsed, index, !this.isCollapsed[index]);

    } ,


  },
      
});


</script>

<template>
  <Layout>
    <Banner pageTitle='QUI SOMMES-NOUS' subtitle1="Fondée en 1990, HA est leader du prêt à porter en Tunisie" subtitle2="Dixaines de magasins répartis sur l’ensemble du territoire tunisien" :small="true" ></Banner>

    <div class="row m-4 p-4">
      <div class="col-12 text-dark font-size-16">

        <p class="text-justify" style="line-height: 30px;
    letter-spacing: 1px;">Fondée en 1990, HA est devenue en 30 ans le leader du prêt à porter en Tunisie.

L’enseigne regroupe actuellement 33 magasins répartis sur l’ensemble du territoire tunisien.

La clairvoyance des équipes opérant au sein de l’enseigne HA lui a permis d’assoir, au fil des années, un positionnement de leader dans le marché du prêt à porter tunisien.

La reconnaissance de la qualité de nos produits, des prix pratiqués et de notre capacité à répondre aux besoins spécifiques du marché tunisien nous ont permis de devenir la marque préférée des tunisiens.

Notre stratégie nous a permis de developer la notoriété de la marque HA sur l’ensemble du territoire tunisien et sur les pays limitrophes.

Dès les premières années du projet, le fondateur de l’enseigne a mis un poing d’honneur à se différencier de la concurrence.</p>

      </div>
    </div>

    <FaqS title="HA le Leader du prêt à porter en Tunisie !" :faqType="1" > </FaqS>

    

  </Layout>
</template>
<style scoped>


</style>
